import React from "react"
import PropTypes from "prop-types"
import ReactPlayer from "react-player/lazy"
import styled from "styled-components"

const ReactPlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  aspect-ratio: 16 / 9;
  box-sizing: border-box;
  background-color: #111;

  .responsiveVideo {
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #111;
  }
`
const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #111;
`
const Video = ({ type, title, url, controls, poster, muted, loop }) => {
  return (
    <ReactPlayerWrapper>
      {type === "rts" ? (
        <iframe
          className="responsiveVideo"
          width="560"
          height="315"
          src={url}
          title={title ?? "video"}
          allowfullscreen
          allow="encrypted-media"
        ></iframe>
      ) : (
        <StyledReactPlayer
          url={url}
          light={poster}
          controls={controls}
          volume={1}
          playing={!!poster}
          muted={muted}
          loop={loop}
          width="100%"
          height="100%"
        />
      )}
    </ReactPlayerWrapper>
  )
}

Video.propTypes = {
  controls: PropTypes.bool,
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  poster: PropTypes.string,
  type: PropTypes.oneOf(["rts", "youtube", "vimeo"]),
  muted: PropTypes.bool,
  loop: PropTypes.bool,
}

Video.defaultProps = {
  controls: true,
  muted: false,
  loop: false,
}

export { Video }
